import { featuredPlatforms } from '@/mocks/homeData';

export default function FeaturedPlatforms() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            精选推荐平台
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            经过严格筛选与深度评测，为您推荐最值得信赖的优质博彩平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredPlatforms.map((platform) => (
            <div
              key={platform.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-accent-300/50 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-background-100">
                  <img
                    src={platform.logo}
                    alt={platform.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-semibold text-foreground-900 mb-1 truncate">
                    {platform.name}
                  </h3>
                  <div className="flex items-center gap-1">
                    <div className="flex items-center">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i
                          key={i}
                          className={`text-xs ${
                            i < Math.floor(platform.rating)
                              ? 'ri-star-fill text-accent-500'
                              : i < platform.rating
                              ? 'ri-star-half-fill text-accent-500'
                              : 'ri-star-line text-foreground-300'
                          }`}
                        ></i>
                      ))}
                    </div>
                    <span className="text-sm font-semibold text-accent-600 ml-1">{platform.rating}</span>
                  </div>
                </div>
              </div>

              <div className="bg-accent-50 rounded-md px-3 py-2 mb-3">
                <p className="text-sm text-accent-700 font-medium flex items-center gap-1.5">
                  <i className="ri-gift-line"></i>
                  {platform.bonus}
                </p>
              </div>

              <div className="flex flex-wrap gap-2">
                {platform.features.map((f) => (
                  <span
                    key={f}
                    className="inline-flex items-center px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium"
                  >
                    {f}
                  </span>
                ))}
              </div>

              <a
                href={platform.url}
                className="mt-4 w-full inline-flex items-center justify-center px-4 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                访问平台 <i className="ri-arrow-right-line ml-1.5"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}